import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.object.define-properties";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.array.fill";
import "core-js/modules/es6.array.for-each";
import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/*
 * Vex Chords v2
 * Mohit Muthanna Cheppudira -- http://0xfe.blogspot.com
 */
import { SVG } from '@svgdotjs/svg.js'; // ChordBox implements the rendering logic for the chord
// diagrams.

var ChordBox =
/*#__PURE__*/
function () {
  // sel can be a selector or an element.
  function ChordBox(sel, params) {
    var _this = this;

    _classCallCheck(this, ChordBox);

    this.sel = sel;
    this.params = _objectSpread({}, {
      numStrings: 6,
      numFrets: 5,
      x: 0,
      y: 0,
      width: 100,
      height: 120,
      strokeWidth: 1,
      showTuning: true,
      defaultColor: '#666',
      bgColor: '#fff',
      labelColor: '#fff',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
      fontSize: undefined,
      fontStyle: 'light',
      fontWeight: '100',
      labelWeight: '100'
    }, {}, params); // Setup defaults if not specifically overridden

    ['bridgeColor', 'stringColor', 'fretColor', 'strokeColor', 'textColor'].forEach(function (param) {
      _this.params[param] = _this.params[param] || _this.params.defaultColor;
    });
    ['stringWidth', 'fretWidth'].forEach(function (param) {
      _this.params[param] = _this.params[param] || _this.params.strokeWidth;
    }); // Create canvas and add it to the DOM

    this.canvas = SVG().addTo(sel).size(this.params.width, this.params.height); // Size and shift board

    this.width = this.params.width * 0.75;
    this.height = this.params.height * 0.75;
    this.x = this.params.x + this.params.width * 0.15;
    this.y = this.params.y + this.params.height * 0.15;
    this.numStrings = this.params.numStrings;
    this.numFrets = this.params.numFrets;
    this.spacing = this.width / this.numStrings;
    this.fretSpacing = this.height / (this.numFrets + 2); // Add room on sides for finger positions on 1. and 6. string

    this.x += this.spacing / 2;
    this.y += this.fretSpacing;
    this.metrics = {
      circleRadius: this.width / 20,
      barreRadius: this.width / 25,
      fontSize: this.params.fontSize || Math.ceil(this.width / 8),
      barShiftX: this.width / 28,
      bridgeStrokeWidth: Math.ceil(this.height / 36)
    }; // Content

    this.position = 0;
    this.positionText = 0;
    this.chord = [];
    this.bars = [];
    this.tuning = ['E', 'A', 'D', 'G', 'B', 'E'];
  }

  _createClass(ChordBox, [{
    key: "setNumFrets",
    value: function setNumFrets(numFrets) {
      this.numFrets = numFrets;
      this.fretSpacing = this.height / (this.numFrets + 1);
      return this;
    }
  }, {
    key: "setPositionText",
    value: function setPositionText(position) {
      this.positionText = position;
      return this;
    }
  }, {
    key: "drawText",
    value: function drawText(x, y, msg, attrs) {
      var textAttrs = _objectSpread({}, {
        family: this.params.fontFamily,
        size: this.metrics.fontSize,
        style: this.params.fontStyle,
        weight: this.params.fontWeight
      }, {}, attrs);

      var text = this.canvas.text("".concat(msg)).stroke(this.params.textColor).fill(this.params.textColor).font(textAttrs);
      return text.move(x - text.length() / 2, y);
    }
  }, {
    key: "drawLine",
    value: function drawLine(x, y, newX, newY) {
      return this.canvas.line(0, 0, newX - x, newY - y).move(x, y);
    }
  }, {
    key: "draw",
    value: function draw(_ref) {
      var chord = _ref.chord,
          position = _ref.position,
          barres = _ref.barres,
          positionText = _ref.positionText,
          tuning = _ref.tuning;
      this.chord = chord;
      this.position = position || 0;
      this.positionText = positionText || 0;
      this.barres = barres || [];
      this.tuning = tuning || ['E', 'A', 'D', 'G', 'B', 'E'];

      if (this.tuning.length === 0) {
        this.fretSpacing = this.height / (this.numFrets + 1);
      }

      var spacing = this.spacing;
      var fretSpacing = this.fretSpacing; // Draw guitar bridge

      if (this.position <= 1) {
        var fromX = this.x;
        var fromY = this.y - this.metrics.bridgeStrokeWidth;
        this.canvas.rect(this.x + spacing * (this.numStrings - 1) - fromX, this.y - fromY).move(fromX, fromY).stroke({
          width: 0
        }).fill(this.params.bridgeColor);
      } else {
        // Draw position number
        this.drawText(this.x - this.spacing / 2 - this.spacing * 0.1, this.y + this.fretSpacing * this.positionText, this.position);
      } // Draw strings


      for (var i = 0; i < this.numStrings; i += 1) {
        this.drawLine(this.x + spacing * i, this.y, this.x + spacing * i, this.y + fretSpacing * this.numFrets).stroke({
          width: this.params.stringWidth,
          color: this.params.stringColor
        });
      } // Draw frets


      for (var _i = 0; _i < this.numFrets + 1; _i += 1) {
        this.drawLine(this.x, this.y + fretSpacing * _i, this.x + spacing * (this.numStrings - 1), this.y + fretSpacing * _i).stroke({
          width: this.params.fretWidth,
          color: this.params.fretColor
        });
      } // Draw tuning keys


      if (this.params.showTuning && this.tuning.length !== 0) {
        for (var _i2 = 0; _i2 < Math.min(this.numStrings, this.tuning.length); _i2 += 1) {
          this.drawText(this.x + this.spacing * _i2, this.y + this.numFrets * this.fretSpacing + this.fretSpacing / 12, this.tuning[_i2]);
        }
      } // Draw chord


      for (var _i3 = 0; _i3 < this.chord.length; _i3 += 1) {
        // Light up string, fret, and optional label.
        this.lightUp({
          string: this.chord[_i3][0],
          fret: this.chord[_i3][1],
          label: this.chord.length > 2 ? this.chord[_i3][2] : undefined
        });
      } // Draw barres


      for (var _i4 = 0; _i4 < this.barres.length; _i4 += 1) {
        this.lightBar(this.barres[_i4].fromString, this.barres[_i4].toString, this.barres[_i4].fret);
      }
    }
  }, {
    key: "lightUp",
    value: function lightUp(_ref2) {
      var string = _ref2.string,
          fret = _ref2.fret,
          label = _ref2.label;
      var stringNum = this.numStrings - string;
      var shiftPosition = this.position === 1 && this.positionText === 1 ? this.positionText : 0;
      var mute = fret === 'x';
      var fretNum = fret === 'x' ? 0 : fret - shiftPosition;
      var x = this.x + this.spacing * stringNum;
      var y = this.y + this.fretSpacing * fretNum;

      if (fretNum === 0) {
        y -= this.metrics.bridgeStrokeWidth;
      }

      if (!mute) {
        this.canvas.circle().move(x, y - this.fretSpacing / 2).radius(this.metrics.circleRadius).stroke({
          color: this.params.strokeColor,
          width: this.params.strokeWidth
        }).fill(fretNum > 0 ? this.params.strokeColor : this.params.bgColor);
      } else {
        this.drawText(x, y - this.fretSpacing, 'X');
      }

      if (label) {
        var fontSize = this.metrics.fontSize * 0.55;
        var textYShift = fontSize * 0.66;
        this.drawText(x, y - this.fretSpacing / 2 - textYShift, label, {
          weight: this.params.labelWeight,
          size: fontSize
        }).stroke({
          width: 0.7,
          color: fretNum !== 0 ? this.params.labelColor : this.params.strokeColor
        }).fill(fretNum !== 0 ? this.params.labelColor : this.params.strokeColor);
      }

      return this;
    }
  }, {
    key: "lightBar",
    value: function lightBar(stringFrom, stringTo, theFretNum) {
      var fretNum = theFretNum;

      if (this.position === 1 && this.positionText === 1) {
        fretNum -= this.positionText;
      }

      var stringFromNum = this.numStrings - stringFrom;
      var stringToNum = this.numStrings - stringTo;
      var x = this.x + this.spacing * stringFromNum - this.metrics.barShiftX;
      var xTo = this.x + this.spacing * stringToNum + this.metrics.barShiftX;
      var y = this.y + this.fretSpacing * (fretNum - 1) + this.fretSpacing / 4;
      var yTo = this.y + this.fretSpacing * (fretNum - 1) + this.fretSpacing / 4 * 3;
      this.canvas.rect(xTo - x, yTo - y).move(x, y).radius(this.metrics.barreRadius).fill(this.params.strokeColor);
      return this;
    }
  }]);

  return ChordBox;
}();

export default ChordBox;